import * as React from 'react';
import { SVGProps } from 'react';

const SvgMeasure2Outlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="m6.343 13.414.707-.707 2.122 2.121-.708.708-2.12-2.122ZM11.293 8.465l-.707.707 2.121 2.12.707-.706-2.121-2.121ZM8.464 11.293l.708-.707 2.12 2.121-.706.707-2.122-2.121ZM13.414 6.343l-.707.707 2.121 2.122.708-.707-2.122-2.122Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.1 14.828 5.657 5.657a2 2 0 0 0 2.829 0l9.9-9.9a2 2 0 0 0 0-2.828l-5.658-5.656L2.1 14.828ZM14.828 4.93l-9.9 9.9 4.244 4.242 9.899-9.9-4.243-4.242Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMeasure2Outlined;
